import { Flex } from "@otrium/core";
import styled from "@emotion/styled";
import { ColorCheck } from "src/icons/ColorCheck";
import { FormLabel } from "@otrium/atoms";

const StyledWrapper = styled.div`
  input[type="checkbox"] {
    opacity: 0;
    width: 0;
    margin: ${({ theme }) => theme.space[0]};
  }
`;

const ColorBox = styled(Flex)<{ active?: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 1px;
  ${({ active, theme }) =>
    active &&
    `
  border: 1px solid ${theme.colors.tone.black};
  `}
`;

const CheckboxLabel = styled(FormLabel)`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.tone.black};
`;

const MobileCheckboxLabel = styled(FormLabel)`
  position: relative;
  line-height: 1.5;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.tone.black};
  align-items: center;
`;

const Check = styled(ColorCheck)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export { StyledWrapper, ColorBox, CheckboxLabel, MobileCheckboxLabel, Check };
